export default __webpack_public_path__ + "static/media/icon-avatar.b100d5d9.svg";